/* Model */
class LocationModel extends App.Models.BaseModel {
    modelUrl = 'Location';
    nearGeofenceButton = null;

    keyValidToAddress = (key) => {
        const validAddresses = ['addressLine1', 'addressLine2', 'district', 'city', 'state', 'country', 'zipCode'];
        if (validAddresses.indexOf(key) !== -1) {
            return true;
        }
        return false;
    }

    getItemsOfAddress = () => {
        const __location = this.attributes;
        const addressItems = [];
        for (let key in __location) {
            if (this.keyValidToAddress(key) && __location[key]) {
                if (key === "addressLine1") {
                    addressItems[0] = __location[key];
                }
                if (key === "addressLine2") {
                    addressItems[1] = __location[key];
                }
                if (key === "district") {
                    addressItems[2] = __location[key];
                }
                if (key === "zipCode") {
                    addressItems[3] = __location[key];
                }
                if (key === "city") {
                    addressItems[4] = __location[key];
                }
                if (key === "state") {
                    addressItems[5] = __location[key];
                }
                if (key === "country") {
                    addressItems[6] = __location[key];
                }
            }
        }
        return addressItems.filter(item => (typeof item !== 'undefined'));
    }
}

App.Models.Location = LocationModel;

/* Collection */
class LocationCollection extends App.Collections.BaseCollection {
    url = 'Location';
    model = App.Models.Location;
}

App.Collections.Locations = LocationCollection;

/* Router */
class LocationRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Location';
        const model = App.Models.Location;
        const collectionClass = App.Collections.Locations;

        super(entityName, model, collectionClass);
    }

    beforeList = () => {
        if (this.collectionCriteria) {
            const x = JSON.parse(this.collectionCriteria);
            x.filters.push("deliveryDays");
            this.collectionCriteria = JSON.stringify(x);
        }

        App.Objects.LocationOverrideTimeWindow.locationId = null;
        App.Forms.Location.filterBuilder.setCallbackBeforeFilter(function () {
            let deliveryDays;
            
            this.criteriaChain.criteriaChain.forEach(function (criteria) {
                criteria["and"].forEach(function (field, index, collection) {
                    if (field.attr === "deliveryDays") {
                        deliveryDays = collection[index];
                        collection.splice(index, 1)
                    }
                });
            });

            if (deliveryDays && deliveryDays.eq) {
                this.criteriaChain.criteriaChain[0].and.push(
                    {
                        "or": deliveryDays.eq.split(",").map((or) =>
                            ({
                                "attr": "deliveryDays",
                                "eq": or,
                                "matchMode": Monet.Utils.CriteriaMatchModes.ANYWHERE
                            })
                        )
                    }
                );
            }
        });
    }

    afterCreateForm = () => {
        Monet.FormBuilder.appendUnitySystemMetricToLabel("#Location #Location_deliveryRadius label");
        if (!Monet.Session.Location) {
            Monet.Session.Location = {};
        }

        if (Monet.Session.Location) {
            Monet.Session.Location.Geofence = {};
            Monet.Session.Location.Geofence.serverGeometry = null;
            Monet.Session.Location.Geofence.points = null;
        }

        App.Routers.LocationOverrideTimeWindow.prototype.locationId = null;
    }

    addGeofencePopup = () => {
        const geofenceLink = document.querySelector('#Location #link_geofence');

        if (geofenceLink) {
            geofenceLink.innerHTML = Monet.I18n.getResourcesByKey('Greenmile.Location.Add.Geofence');
            geofenceLink.href = "javascript: App.Objects.Location.showPopup();";

            Monet.Session.Location = Monet.Session.Location || {};
            Monet.Session.Location.Geofence = Monet.Session.Location.Geofence || {};
        }
    }

    createMapOverlay = () => {
        const popupEl = document.querySelector('#Location .span10');
        const linkFormContent = document.createElement('div');
        linkFormContent.id = 'adjustsLayoutContainer';

        const latitudeField = document.querySelector('#Location #Location_latitude input');
        const longitudeField = document.querySelector('#Location #Location_longitude input');

        linkFormContent.className = 'LocationMapForm';

        popupEl.appendChild(linkFormContent);

        this.createMapForms(linkFormContent);

        const addressSearchField = document.querySelector('#Location #searchStreet');
        addressSearchField.value = this.formatAddress();

        delete Monet.Session.Location.Geofence.locationConfirmed;

        if (!latitudeField.value && !longitudeField.value) {
            $(addressSearchField).trigger("keydown");
        }
    }

    getLocationPosition = () => {
        const center = {};
        const lat = document.querySelector('#Location #Location_latitude input');
        if (lat) {
            center.lat = lat.value;
        }

        const lng = document.querySelector('#Location #Location_longitude input');
        if (lng) {
            center.lng = lng.value;
        }
        return center;
    };

    formatAddress = () => {
        const formFields = App.Forms.Location.form.fields;
        const addressLine1Field = formFields.addressLine1;
        const addressLine2Field = formFields.addressLine2;
        const cityField = formFields.city;
        const stateField = formFields.state;
        const zipCodeField = formFields.zipCode;
        const countryField = formFields.country;
        const districtField = formFields.district;

        let textAddress = '';
        function appendAddressData (addressField) {
            if (addressField && addressField.getValue()) {
                textAddress += addressField.getValue() + ', ';
            }
        }

        appendAddressData(addressLine1Field);
        appendAddressData(addressLine2Field);
        appendAddressData(districtField);
        appendAddressData(cityField);
        appendAddressData(stateField);
        appendAddressData(countryField);
        appendAddressData(zipCodeField);
        return textAddress;
    };

    createMapForms = (linkFormContent) => {

        const textAddress = this.formatAddress();

        const mapContainer = document.createElement('div');
        mapContainer.id = 'locationGeocodeMapContainer';
        mapContainer.className = 'locationGeocodeMapContainer';

        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'locationGeocodeButtonBoxMapsContainer';

        const saveButton = document.createElement('input');
        saveButton.type = 'button';
        saveButton.name = 'locationGeocodePopupSave';
        saveButton.id = 'locationGeocodePopupSave';
        saveButton.value = Monet.I18n.getResourcesByKey('general.button.ok');

        const cancelButton = document.createElement('input');
        cancelButton.type = 'button';
        cancelButton.name = 'locationGeocodePopupCancel';
        cancelButton.id = 'locationGeocodePopupCancel';
        cancelButton.value = Monet.I18n.getResourcesByKey('default.button.cancel');
        cancelButton.setAttribute("class", "btn-secondary");

        const addressContainer = document.createElement('div');
        addressContainer.className = 'locationGeocodeAddressContainer';

        const nameField = document.querySelector('#Location #Location_description input');
        const keyField = document.querySelector('#Location #Location_key input');

        if (keyField.innerHTML) {
            addressContainer.innerHTML = '<h3> #' + keyField.innerHTML + ' - ' + nameField.value + '</h3>';
        }

        addressContainer.innerHTML += textAddress;

        addressContainer.addEventListener('click', (function (textAddress) {
            return function () {
                var addressSearchField = document.querySelector('#Location #searchStreet');

                addressSearchField.value = textAddress;

                $(addressSearchField).trigger("focus");
                $(addressSearchField).trigger("keydown");
            };
        }(textAddress)));

        buttonsContainer.appendChild(cancelButton);
        buttonsContainer.appendChild(saveButton);

        linkFormContent.appendChild(mapContainer);
        linkFormContent.appendChild(buttonsContainer);
        linkFormContent.appendChild(addressContainer);

        this.addButtonListeners(saveButton, cancelButton);

        const mapConfs = Greenmile.Map.Utility.getMapLocalStorageConfiguration();
        const latLng = this.getLocationPosition();
        const lat = latLng.lat || mapConfs.latitude;
        const lng = latLng.lng || mapConfs.longitude;
        
        const map = Greenmile.Map.Utility.createDefaultMap('locationGeocodeMapContainer');
        const baseLayer = Greenmile.Map.Utility.createBaseLayer();
        
        baseLayer.addTo(map);
        map.panTo(new L.LatLng(lat, lng));
        
        if (latLng.lat) {
            const locationIcon = L.icon({
                iconUrl: require('static/images/map/markers/location.png'),
                iconSize: [20, 20],
                popupAnchor: [37, 0]
            });
            
            if (latLng.lat && latLng.lng) {
                const marker = L.marker([latLng.lat, latLng.lng], {
                    icon: locationIcon,
                    draggable: true
                });
                const htmlPop = document.createElement('div');
                htmlPop.className = "address";
                
                const btn = document.createElement('input');
                btn.type = 'button';
                btn.value = Monet.I18n.getResourcesByKey('Location.Geocode.ConfirmPosition');
                btn.className = 'locationGeocodeConfirmBtn';
                htmlPop.appendChild(btn);

                btn.onclick = (function (marker) {
                    return function () {
                        marker.closePopup();
                        App.Objects.Location.removeNearGeofences();
                        App.Forms.Location.form.model.set("latitude", marker._latlng.lat);
                        App.Forms.Location.form.model.set("longitude", marker._latlng.lng);
                        App.Objects.Location.afterPopulateForm(App.Forms.Location.form.model);
                    };
                }(marker));

                marker.bindPopup(htmlPop);
                marker.on('dragend', (e) => {
                    e.target.openPopup();
                    Monet.Session.Location.Geofence.locationConfirmed = e.target;
                });
                marker.kind = 'LATLNG_MARKER';
                marker.addTo(map);
                map.setView([latLng.lat, latLng.lng], 18);
            }
        }

        const selector = mapContainer.className;
        const options = {};
        const mapSourceControl = new Greenmile.Toolbar.Map.MapSourceControl(selector, map, options);
        mapSourceControl.setSourceMap(mapConfs.supplierMap, map, {
            mapBaseLayer: baseLayer
        });

        this.addToolbar(map, baseLayer, '.LocationMapForm');
        var draw = this.addDrawTool(map);
        this.addRemoveButton();
        this.addNearGeofenceButton();
        this.drawGeofence(map, draw);
        Monet.Session.Location.Geofence.draw = draw;
        Monet.Session.Location.Geofence.map = map;

        $('#Location #locationGeocodeMapContainer').on('click', () => ($("#Location .streetSearchResult").hide()) );
    };

    registerMapDrawListeners = (map, draw) => {
        const drawnItems = draw.drawnItems;
        const getLatLngs = (layer) => ( layer.getLatLngs()[0] );

        map.on('draw:created', (e) => {
            const layer = e.layer;
            drawnItems.clearLayers();
            drawnItems.addLayer(layer);
            Monet.Session.Location.Geofence.points = getLatLngs(layer);
            draw.disableDraw();
            this.enableRemoveButton();
        });

        map.on('draw:deleted', () => {
            Monet.Session.Location.Geofence.points = null;
            draw.enableDraw();
            this.disableRemoveButton();
        });

        map.on('draw:edited', (e) => {
            var layers = e.layers;
            layers.eachLayer( (layer)=> Monet.Session.Location.Geofence.points = getLatLngs(layer) );
        });
    };

    generateColor = () => ("rgb(" + [Math.floor(Math.random() * 254), Math.floor(Math.random() * 254), 0].join(",") + ")");

    drawNearGeofence = (map) => {
        Monet.Session.Location.Geofence.nearGeofencesPolygon = Monet.Session.Location.Geofence.nearGeofencesPolygon || [];
        const location = Monet.Session.Location.Geofence.NearGeofence;
        const options = {color: "yellow"};
        let points = null;
        const markerLocation = new Greenmile.MarkerLocation.GeneralFunctions();

        if (!location  || !location.nearGeofence) {
            return;
        }

        location.nearGeofence.forEach((nearGeofence) => {
            if (!nearGeofence.geofence) {
                return;
            }
            options.color = this.generateColor();
            points = nearGeofence.geofence.map(function (geofence) {
                return [geofence.latitude, geofence.longitude];
            });
            const polygon = new L.Polygon(points, options);
            const polygonOptions = {
                offset: L.point(35, 18)
            }
            map.addLayer(polygon);
            polygon.bringToBack();
            polygon.bindPopup(markerLocation.renderContentToPopup(nearGeofence.location, null, true), polygonOptions);
            Monet.Session.Location.Geofence.nearGeofencesPolygon.push(polygon);
        });
    };

    toggleNearGeofence = () => {
        const userPreferences = new Greenmile.UserPreferences.Actions();
        const map = Monet.Session.Location.Geofence.map;
        const nearGeofenceButton = document.querySelector('#Location div.leaflet-draw-section div.leaflet-draw-toolbar.leaflet-bar .nearGeofenceButton');

        if (!Monet.Session.sessionStorage.getItem("nearGeofence") || Monet.Session.sessionStorage.getItem("nearGeofence") === "true") {
            this.removeNearGeofences();
            Monet.Session.sessionStorage.setItem("nearGeofence", "false");
            nearGeofenceButton.className = nearGeofenceButton.className.replace("activated", "").trim();
            userPreferences.saveOrUpdateSingleUserPreference("nearGeofence");
        } else {
            this.drawNearGeofence(map);
            Monet.Session.sessionStorage.setItem("nearGeofence", "true");
            nearGeofenceButton.className += " activated";
            userPreferences.saveOrUpdateSingleUserPreference("nearGeofence");
        }
    }

    removeNearGeofences = () => {
        const nearGeofencesPolygon = Monet.Session.Location.Geofence.nearGeofencesPolygon;
        const map                  = Monet.Session.Location.Geofence.map;

        if (nearGeofencesPolygon && nearGeofencesPolygon.length) {
            nearGeofencesPolygon.forEach((polygon) => (map.removeLayer(polygon)));
            Monet.Session.Location.Geofence.nearGeofencesPolygon = [];
        }
    }

    drawGeofence = (map, draw) => {
        let polygon,
            location,
            points,
            wasDeleted = Monet.Session.Location.Geofence.wasDeleted;

        this.registerMapDrawListeners(map, draw);
        location = Monet.Session.Location.Geofence.NearGeofence || {};
        points = (!wasDeleted ? Monet.Session.Location.Geofence.points || location.geofence : null);

        if (points && points.length) {
            points = points.map((point) => ([point.lat || point[0] || point.latitude, point.lng || point[1] || point.longitude]));
            Monet.Session.Location.Geofence.points = points;
        } else {
            points = Monet.Session.Location.Geofence.previousPolygon;
        }
        
        if (!Monet.Session.sessionStorage.getItem("nearGeofence") || Monet.Session.sessionStorage.getItem("nearGeofence") === "true") {
            this.drawNearGeofence(map);
        }
        
        if (points && points.length && !wasDeleted) {
            //if user click on cancel button, this will be Monet.Session.Location.Geofence.points
            Monet.Session.Location.Geofence.previousPolygon = points;
            polygon = new L.Polygon(points, {color: 'blue'});
            draw.points = points;
            draw.drawnItems.clearLayers();
            draw.drawnItems.addLayer(polygon);

            draw.disableDraw();
            this.enableRemoveButton();
        }
    }

    addDrawTool = (map) => {
        const draw = new Greenmile.Geofence.DrawTool(map, null, 'Location');
        draw.init();
        this.registerMapDrawListeners(map, draw);
        return draw;
    };

    addToolbar = (map, baseLayer, mapSelector) => {
        const options = {
            screenRoute: {
                mapBaseLayer: baseLayer
            }
        };
        const help = new Monet.UI.Help('LocationGeofenceMap', Monet.I18n.getResourcesByKey('location.userinterface.description'));
        const toolbar = new Greenmile.Toolbar.Map(map, mapSelector, options, help);

        toolbar.enable([
            toolbar.actions.searchAddressOnMap,
            toolbar.actions.street,
            toolbar.actions.zoom,
            toolbar.actions.source
        ]);

        toolbar.setProperty('searchAddressOnMap', {
            action: () => (new Greenmile.Toolbar.Map.LocationGeocode(mapSelector, map)),
            enable: true,
            template: {
                selector: '#searchAddressOnMap_template',
                position: 'left'
            }
        });

        toolbar.render();
    };

    addButtonListeners = (saveButton, cancelBtn) => {
        cancelBtn.addEventListener('click', () => {
            const previous = Monet.Session.Location.Geofence.previousPolygon;

            if (previous) {
                Monet.Session.Location.Geofence.points = previous;
                Monet.Session.Location.Geofence.wasDeleted = false;
                delete Monet.Session.Location.Geofence.locationConfirmed;
            }

            if (!Monet.Session.Location.Geofence.serverGeometry) {
                Monet.Session.Location.Geofence.points = null;
            }

            const streetViewCloseButton = document.querySelector('#Location .streetViewCloseBtn');
            if (streetViewCloseButton) {
                streetViewCloseButton.click();
            }

            this.destroyMapOverlay(this);
        });

        saveButton.addEventListener('click', () => {
            const fields = App.Forms.Location.form.fields;
            const latitudeField = fields.latitude;
            const longitudeField = fields.longitude;
            const geocodingQualityField = fields.geocodingQuality;
            const dateFormatted = Monet.Format.DateTime.getTodayISOString();

            if (Monet.Session.Location.Geofence.locationConfirmed) {
                geocodingQualityField.setValue('MANUAL');
                latitudeField.setValue(Monet.Session.Location.Geofence.locationConfirmed._latlng.lat);
                longitudeField.setValue(Monet.Session.Location.Geofence.locationConfirmed._latlng.lng);

                Monet.Session.Location.geocodeLocation = {};
                Monet.Session.Location.geocodeLocation.geocodingUser = { id: Monet.Session.User.id };
                Monet.Session.Location.geocodeLocation.geocodingDate = dateFormatted;
            } 
            
            if (!Monet.Session.Location.Geofence.points && Monet.Session.Location.Geofence.previousPolygon) {
                Monet.Session.Location.Geofence.previousPolygon = [];
                Monet.Session.Location.Geofence.wasDeleted = true;
            } else {
                Monet.Session.Location.Geofence.wasDeleted = false;
            }
            
            //do nothing because the geometry is saved on
            //Monet.Session.Location.Geofence.geometry  namespace and
            //will be used on beforeUpdate.
            this.destroyMapOverlay(this);
        });
    }

    destroyMapOverlay = () => {
        const overlay = document.querySelector('.LocationMapForm');
        overlay.parentNode.removeChild(overlay);
    }

    showPopup = () => {
        this.createMapOverlay();
        App.Objects.Location.afterPopulateForm(App.Forms.Location.form.model);
    }

    resetLatAndLongFields = () => {
        App.Forms.Location.form.model.unset('latitude');
        App.Forms.Location.form.model.unset('longitude');
    }

    beforeCreate = (model) => {
        Monet.Session.Location.geocodeLocation = {};

        const { latitude, longitude } = App.Forms.Location.form.fields;
        const hasLatitudeValue = latitude.value.length;
        const hasLongitudeValue = longitude.value.length;

        if (hasLatitudeValue || hasLongitudeValue) {
            const attributes = model.attributes;

            const dateFormatted = Monet.Format.DateTime.getTodayISOString();
            Monet.Session.Location.geocodeLocation.geocodingDate = dateFormatted;
            this.updateModelWithGeocode(attributes);
        } else {
            this.resetLatAndLongFields();
        }

        this.addGeofenceOnModel(model);
    }

    beforeUpdate = (model) => {
        const geocodeLocation = Monet.Session?.Location?.geocodeLocation;
        if (geocodeLocation?.geocodingUser || geocodeLocation?.geocodingDate) {
            this.updateModelWithGeocode(model);
        }
        this.addGeofenceOnModel(model);
    }

    updateModelWithGeocode = (model) => {
        model.geocodingUser = Monet.Session.Location.geocodeLocation.geocodingUser;
        model.geocodingDate = Monet.Session.Location.geocodeLocation.geocodingDate;
        Monet.Session.Location.geocodeLocation = {};
    }

    afterCreate = () => {
        App.Objects.RouteDetails.shouldUpdateAll(true);
        window.location = "#/Location";
    }

    validateLatLong = ({
        latitude,
        longitude
    }) => {
        if (!longitude || !latitude) {
            return false;
        }   

        const coordinatesGeneralFunctions = new Greenmile.Coordinates.GeneralFunctions();
        const { isLatitude, isLongitude } = coordinatesGeneralFunctions;

        if (!isLatitude(latitude) || !isLongitude(longitude)) {
            new Greenmile.Components
                .AlertModal('Location.InvalidCoordinatePosition')
                .show();

            return false;
        }

        return true;
    };

    afterPopulateForm = (model) => {
        if (Monet.Session.Location && Monet.Session.Location.Geofence) {
            Monet.Session.Location.Geofence.NearGeofence = null;
        }

        if (model) {
            const { geocodingDate } = model.attributes;

            if (geocodingDate) {
                Monet.Session.Location.geocodeLocation = {};
                Monet.Session.Location.geocodeLocation.geocodingDate = geocodingDate;
            }

            const fields = App.Forms.Location.form.fields;
            const latitude = fields.latitude.getValue();
            const longitude = fields.longitude.getValue();

            const success = (data) => {
                Monet.Session.Location.Geofence.NearGeofence = data;
                const map = Monet.Session.Location.Geofence.map;
                const draw = Monet.Session.Location.Geofence.draw;

                if (map && draw) {
                    this.drawGeofence(map, draw);

                    if (draw.points && draw.points.length) {
                      map.fitBounds(draw.points);
                    }
                }
            };

            if (!this.validateLatLong({
                latitude,
                longitude
            })) {
                success(null);

                return;
            }
            
            const ajax = new Monet.Ajax();

            ajax.url = 'Location/NearGeofences/' + (model.id || "");
            ajax.method = 'POST';
            ajax.data = {
                longitude: longitude,
                latitude: latitude
            };
            ajax.success = success;
            ajax.error = (xhr) => Monet.Configurations.errorNotification(null, xhr, null, null);
            ajax.send();
        }
    }

    addGeofenceOnModel = (model) => {
        const fields = App.Forms.Location.form.fields;
        if (Monet.Session.Location && Monet.Session.Location.Geofence 
            && (Monet.Session.Location.Geofence.locationConfirmed || (fields.latitude.value && fields.longitude.value))) {
            const draw = Monet.Session.Location.Geofence.draw;
            if (draw) {
                const layerGroup = draw.drawnItems;
                const layer = layerGroup.getLayers()[0];

                if (layer && Monet.Session.Location.Geofence.points) {
                    const latlngs = layer.getLatLngs()[0];
                    if (latlngs) {
                        let points = [];
                        model.geofence = [];
                        if (model.attributes) {
                            model.attributes.geofence = [];
                        }

                        if (latlngs && latlngs.length > 0) {
                            points = latlngs.map( (point) => ({ latitude: point.lat, longitude: point.lng }));
                            points.push(points[0]);

                            model.geofence = points;
                            if (model.attributes) {
                                model.attributes.geofence = points;
                            }
                        }
                    }
                } else if (Monet.Session.Location.Geofence.wasDeleted) {
                    const ajax = new Monet.Ajax();
                    ajax.url = 'Location/Geofence/Delete';
                    ajax.method = 'POST';
                    ajax.data = { id: model.id };
                    ajax.success = () => ( console.log('Geofence deleted') );
                    ajax.error = (xhr) => ( Monet.Configurations.errorNotification(null, xhr, null, null) );
                    ajax.send();
                }
            }

            Monet.Session.Location.Geofence = {};
        }
    }

    removeGeofence = () => {
        const enable = document.querySelector('#Location .leaflet-draw-edit-remove.leaflet-enable');
        if (enable) {

            const removeGeofenceAction = () => {
                const draw = Monet.Session.Location.Geofence.draw;
                draw.points = null;
                Monet.Session.Location.Geofence.serverGeometry = null;
                Monet.Session.Location.Geofence.points = null;
                Monet.Session.Location.Geofence.wasDeleted = true;
                draw.drawnItems.clearLayers();
                draw.enableDraw();
                this.disableRemoveButton();
            };

            new Greenmile.Components.AlertModal('geofence.confirm.remove.polygon',
                    null,
                    removeGeofenceAction.bind(this)
                )
                .show();
        }
    }

    addRemoveButton = () => {
        const divMenu = document.querySelector('#Location div.leaflet-draw-section div.leaflet-draw-toolbar.leaflet-bar .leaflet-draw-edit-edit');
        if (divMenu) {
            const remove = document.createElement('a');
            remove.className = '#Location leaflet-draw-edit-remove leaflet-disabled';
            remove.href = "javascript: App.Objects.Location.removeGeofence();";
            L.DomEvent.on(remove, 'dblclick', L.DomEvent.stopPropagation);
            divMenu.parentNode.appendChild(remove);
        }
    }

    addNearGeofenceButton = () => {
        const divMenu = document.querySelector('#Location div.leaflet-draw-section div.leaflet-draw-toolbar.leaflet-bar .leaflet-draw-edit-edit');
        if (divMenu) {
            const near = document.createElement('a');
            near.className = '#Location nearGeofenceButton leaflet-enable';
            near.title = Monet.I18n.getResourcesByKey("toggle.nearGeofence");

            if (!Monet.Session.sessionStorage.getItem("nearGeofence") || Monet.Session.sessionStorage.getItem("nearGeofence") === "true") {
               near.className += " activated";
            }

            near.href = "javascript: App.Objects.Location.toggleNearGeofence();";
            L.DomEvent.on(near, 'dblclick', L.DomEvent.stopPropagation);
            divMenu.parentNode.appendChild(near);
            this.nearGeofenceButton = near;
        }
    }

    disableRemoveButton = () => {
        const remove = document.querySelector('#Location a.leaflet-draw-edit-remove.leaflet-enable');
        remove.className = '#Location leaflet-draw-edit-remove leaflet-disabled';
    }


    enableRemoveButton = () => {
        const remove = document.querySelector('#Location a.leaflet-draw-edit-remove.leaflet-disabled');
        if (remove) {
            remove.className = '#Location leaflet-draw-edit-remove leaflet-enable';
        }
    }
}

App.Routers.Location = LocationRouter;
